import { connect } from 'react-redux'
import Pupils from './pupils'
import { getSchoolId } from '../../../stores/me/me.selectors'
import { fetchPupils } from '../../../stores/pupils/pupils.actions'
import { getPupilsFetchingStatus } from '../../../stores/pupils/pupils.selectors.js'
import { withMe } from 'pobble-components/dist/pobble-user'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { fetchGroups } from '../../../stores/groups/groups.actions'

const mapStateToProps = (state, { me }) => {
  const { pending, requestError } = getPupilsFetchingStatus(state)
  return {
    schoolId: getSchoolId(me),
    showLoadingScreen: pending,
    showPupilsComponent: !pending && !requestError
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch: dispatch
})

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...ownProps,
  ...stateProps,
  onMount: () => {
    dispatch(fetchGroups(stateProps.schoolId)).catch(errorHandler)
    dispatch(fetchPupils(stateProps.schoolId)).catch(errorHandler)
  }
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(Pupils)
)
